<template lang="html">
  <div class="notice_content">
    <div class="divider_line"><span>中标项目</span></div>
    <div class="list_div">
        <Table
          :columns="columns"
          :data="list"
          v-if="total > 0">
        </Table>
        <div class="page clear" v-if="total > 10">
            <Page :total="total" :page-size="10" show-total class="page_list" @on-change="handlePage" show-elevator/>
        </div>
    </div>
    <Nothing v-if="total == 0 && !spinShow">
      <p>暂无相关中标项目</p>
    </Nothing>
    <Spin fix v-if="spinShow">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>Loading</div>
    </Spin>
  </div>
</template>

<script>
import { biddingList, getMeta } from '../../../service'
import filter from 'js/filter'
import Nothing from '@/components/Nothing2'
export default {
  data() {
    return {
      spinShow: true,
      list: [],
      total: 0,
      bidding_type: [],
      params: {
        user_key: this.$store.state.user_key,
        zhongbiao_entity_uid: this.$route.params.uid,
        page: 1
      },
      columns: [
        {title: '中标项目名称',width: 240,key: 'title',render: (h, params) => {
            return h('a', {
              on: {
                click: () => {
                  this.goBiddingDetail(params.row.id)
                }
              },
              class: {
                'dec-clamp': true
              }
            }, params.row.project_ele_name)
          }
        },
        {
          title: '项目地区',
          width: 106,
          render: (h, params) => {
            return h('span', filter.addressDeal(params.row.address_id, '2'))
          }
        },
        {
          title: '项目标签',
          width: 200,
          render: (h, params) => {
            let temp_str = ''
            for(let i = 0;i < params.row.project_ele_type.length; i++) {
              if(i == 0) {
                temp_str += filter.dealName(params.row.project_ele_type[i], this.bidding_type)
              } else {
                temp_str = temp_str+'、'+filter.dealName(params.row.project_ele_type[i], this.bidding_type)
              }
            }
            return h('span', temp_str)
          }
        },
        {
          title: '中标金额',
          width: 134,
          render: (h, params) => {
            return h('span', params.row.winning_bid_amount?parseFloat(params.row.winning_bid_amount)+'万人民币':'未透露')
          }
        },
        {
          title: '采购单位',
          width: 110,
          render: (h, params) => {
            if(params.row.entity_uid) {
              let temp_h = h('span', '--')
              if(params.row.project_entity_type == '0'
              ||params.row.project_entity_type == '1'
              ||params.row.project_entity_type == '2'
              ||params.row.project_entity_type == '3'){
                  temp_h = (h('a',{
                  on: {
                      click: () => {
                      this.goEntityDetail(params.row.entity_uid, params.row.project_entity_type)
                      }
                  },
                  class: {
                      'dec-clamp': true
                  }
                  },  params.row.project_entity_short_name))
              } else {
                   temp_h = (h('span',
                  params.row.project_entity_short_name))
              }
              return h('div', [temp_h])
            } else {
              return h('span', '--')
            }
          }
        },
        {
          title: '中标时间',
          // width: 100,
          render: (h, params) => {
            return h('span', filter.time_moment(params.row.winning_bid_time,'YYYY-MM-DD'))
          }
        }
      ]
    }
  },
  components: {
    Nothing
  },
  methods: {
    async getDetail() {
      let res = await biddingList(this.params, (error) => {
        this.$Message.error('请求错误！')
      })
      if(res.status == 'success') {
        this.$set(this.$data, 'list', res.res)
        if(this.list.length > 0) this.$emit('callbackData', 'Win')
        if(this.params.page == 1) this.total = res.count
        this.spinShow = false;
      } else {
        this.$Message.error(res.msg)
      }
      this.$nextTick(() => {this.spinShow = false})
    },
    handlePage(page) {
      this.params.page = page
      this.getDetail()
    },
    goEntityDetail(uid, type, query) {
        if (type == 2) {
          // this.$router.push({name: 'PeoDetail', params: {uid: uid}})
          const {
            href
          } = this.$router.resolve({
            name: "PeoDetail",
            params: {
              uid: uid
            },
            query: query?query:{}
          })
          window.open(href, '_blank')
        } else if (type == 1) {
          // this.$router.push({name: 'OrgDetail', params: {uid: uid}})
          const {
            href
          } = this.$router.resolve({
            name: "OrgDetail",
            params: {
              uid: uid
            },
            query: query?query:{}
          })
          window.open(href, '_blank')
        } else if (type == 0) {
          // this.$router.push({name: 'CompanyDetail', params: {uid: uid}})
          const {
            href
          } = this.$router.resolve({
            name: "CompanyDetail",
            params: {
              uid: uid
            },
            query: query?query:{}
          })
          window.open(href, '_blank')
        } else if (type == 3) {
          // this.$router.push({name: 'HospitalDetail', params: {uid: uid}})
          const {
            href
          } = this.$router.resolve({
            name: "HospitalDetail",
            params: {
              uid: uid
            },
            query: query?query:{}
          })
          window.open(href, '_blank')
        }
    },
    goBiddingDetail(id) {
        const {
          href
        } = this.$router.resolve({
          name: "TenderDetail",
          params: {
            id: id
          }
        })
        window.open(href, '_blank')
    },
    async getMeta() {
      let res = await getMeta({
        name: ['bidding_type']
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.$set(this.$data, 'bidding_type', res.meta.bidding_type)
      } else {
        this.$Message.error(res.message)
      }
    }
  },
  created() {
    this.getDetail()
    this.getMeta()
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
.notice_content
  padding: 32px
  .divider_line
    margin: 0 0 32px
.ivu-table-wrapper >>> a.upload_ico
  color: rgba(250, 122, 80, 1)
  .iconfont
    display: inline-table
    vertical-align: top
    font-size: 14px
    margin-right: 4px
</style>
